export default __webpack_public_path__ + "static/media/logo_header.7d0fc34b.jpeg";